import { useState, useEffect, useContext } from 'react';

import { ContainerWidthContext } from 'utils/context/ContainerWidthContext';

const parseWidthQuery = (
  query: string,
): { type: 'max' | 'min'; px: number } | null => {
  const match = query.match(/\((max|min)-width:\s*(\d+)px\)/);
  if (!match) return null;
  return { type: match[1] as 'max' | 'min', px: Number(match[2]) };
};

const useMediaQuery = (query: string): boolean => {
  const containerWidth = useContext(ContainerWidthContext);
  const parsed = containerWidth != null ? parseWidthQuery(query) : null;

  const evaluate = (): boolean => {
    if (containerWidth != null && parsed) {
      return parsed.type === 'max'
        ? containerWidth <= parsed.px
        : containerWidth >= parsed.px;
    }
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState<boolean>(evaluate);

  useEffect(() => {
    setMatches(evaluate());
    if (containerWidth != null && parsed) return;
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, containerWidth]);

  return matches;
};

export default useMediaQuery;
